module.exports = __webpack_public_path__ + "img/terroir-tinted-1.aa02054f.jpg";